<div class="container-fluid p-0" dir="{{'textDir' | translate}}">
    <div class="row">
        <div class="col-12">
            <div class="login-card">
                <div>
                    <div>
                        <a class="logo" routerLink='/'>
                            <img class="img-fluid for-light" src="assets/images/logo/login.png" alt="looginpage">
                            <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="looginpage">
                        </a>
                    </div>
                    <div class="login-main">
                        <form class="theme-form" [formGroup]="loginForm">
                            <h4 style="text-align: center;">{{'Login' | translate }}</h4>
                            <div class="form-group">
                                <label class="col-form-label">{{'Username' | translate}}</label>
                                <input class="form-control" type="text" required="" placeholder="{{'Username' | translate}}" formControlName="username">
                                <div *ngIf="loginForm.controls.username.touched && loginForm.controls.username.errors?.required"
                                     class="text text-danger mt-1">
                                    {{'UsernameIsRequired' | translate }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">{{'Password' | translate}}</label>
                                <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="password" required=""  placeholder="{{'Password' | translate}}"  (keyup.enter)="login()">
                                <div style="margin-right:233px; width: 100px;display:flex;justify-content: end; align-items: center;" class="show-hide"  *ngIf="!show"><span style="color:  #39A189;" (click)="showPassword()" class="show"></span></div>
                                <div style="margin-right:233px; width: 100px; display: flex; justify-content: end; align-items: center;" class="show-hide" *ngIf="show"><span style="color:  #39A189;" (click)="showPassword()" class="Hide"></span></div>
                                <div *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.required"
                                     class="text text-danger mt-1">
                                    {{'PasswordIsRequired' | translate}}
                                </div>
                            </div>
                            <div class="form-group mb-0">

                                <button class="btn btn-primary d-block w-100"
                                        [disabled]="btnDisabled"
                                        (click)="login()"
                                        type="button"> {{'Login'|translate}}
                                </button>
                            </div>



                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>